import { render, staticRenderFns } from "./NombreEtablissementParClassement.vue?vue&type=template&id=05e919da&"
import script from "./NombreEtablissementParClassement.vue?vue&type=script&lang=js&"
export * from "./NombreEtablissementParClassement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports